import React, { useMemo } from 'react';
import { UserGroupIcon } from '@heroicons/react/24/outline';
import type { Group } from './types';

export interface KpiAssignmentGroupQuickSelectProps {
  groups: Group[];
  value: string;
  onChange: (groupId: string) => void;
}

const KpiAssignmentGroupQuickSelect: React.FC<KpiAssignmentGroupQuickSelectProps> = ({
  groups,
  value,
  onChange,
}) => {
  const tabs = useMemo(() => [{ id: 'All', name: 'All' } as const, ...groups], [groups]);

  return (
    <div className="ml-auto flex w-full min-w-0 max-w-full flex-col items-end sm:max-w-[min(100%,22rem)] md:max-w-[min(100%,32rem)] lg:max-w-[min(100%,40rem)] xl:max-w-[min(100%,48rem)]">
      {/* <div className="mb-1 flex items-center justify-end gap-1 text-[10px] font-semibold uppercase tracking-wide text-slate-500">
        <UserGroupIcon className="h-3 w-3 shrink-0" aria-hidden />
        <span>Assignment group</span>
      </div> */}
      <div
        className="flex w-full flex-wrap justify-end gap-x-1 gap-y-1"
        role="tablist"
        aria-label="Filter by assignment group"
      >
        {tabs.map((tab) => {
          const selected = tab.id === 'All' ? value === 'All' : value === tab.id;
          return (
            <button
              key={tab.id}
              type="button"
              role="tab"
              aria-selected={selected}
              tabIndex={selected ? 0 : -1}
              onClick={() => onChange(tab.id)}
              className={`max-w-full rounded-md border px-1.5 py-0.5 text-left text-[10px] font-medium leading-tight transition-colors sm:px-2 sm:py-1 sm:text-[11px] ${
                selected
                  ? 'border-indigo-600 bg-indigo-600 text-white shadow-sm'
                  : 'border-slate-200/90 bg-white text-slate-600 hover:border-slate-300 hover:bg-slate-50'
              }`}
              title={tab.name}
            >
              <span className="block max-w-[9rem] truncate sm:max-w-[11rem]">{tab.name}</span>
            </button>
          );
        })}
      </div>
    </div>
  );
};

export default KpiAssignmentGroupQuickSelect;
